if (!customElements.get('participation-pdp')) {
  customElements.define('participation-pdp', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const on = (element, event, callback, options = {}) => element?.addEventListener(event, callback, { ...options, signal });
      const one = selector => this.querySelector(selector);
      const all = selector => [...this.querySelectorAll(selector)];
      const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const form = one('.oct-form');
      const add = one('[data-add]');
      const error = one('[data-form-error]');
      const buy = one('.oct-buy');
      const sticky = one('[data-sticky-cart]');
      const sizeInputs = all('.oct-size input');
      if (this.dataset.requireSizeChoice === 'true' && !this.hasExplicitSizeChoice) {
        sizeInputs.forEach(input => { input.checked = false; });
      }
      const tabs = all('[role="tab"]');
      const gallery = one('.oct-gallery');
      const chart = one('.oct-size-dialog');
      let frame = 0;
      const updateSticky = () => {
        frame = 0;
        const anchor = (add.hidden ? one('[data-email-dialog]') : add) || add;
        const naturalBottom = one('.oct-buy-column').getBoundingClientRect().top + anchor.getBoundingClientRect().bottom - buy.getBoundingClientRect().top;
        const footer = document.querySelector('footer, [role="contentinfo"]');
        const footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
        const mobile = matchMedia('(max-width: 1023px)').matches;
        const active = document.activeElement;
        const editing = active && active.matches('textarea, select, input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]):not([type="hidden"])');
        let mainActionPassed = false;
        if (mobile) {
          const mainControl = add.hidden ? one('[data-email-dialog] button[type="submit"]') || anchor : add;
          const rect = mainControl.getBoundingClientRect();
          const viewport = window.visualViewport;
          let viewportTop = viewport?.offsetTop || 0;
          const viewportBottom = Math.min(window.innerHeight, viewportTop + (viewport?.height || window.innerHeight));
          const headerRect = document.querySelector('header')?.getBoundingClientRect();
          if (headerRect && headerRect.top <= viewportTop + 1 && headerRect.bottom > viewportTop) {
            viewportTop = Math.min(headerRect.bottom, viewportBottom);
          }
          mainActionPassed = rect.height > 0 && rect.bottom <= viewportTop;
        }
        const visible = mobile ? !editing && mainActionPassed : naturalBottom <= 60 && !footerVisible;
        sticky.hidden = !visible;
        const stickyButton = one('[data-sticky-add]');
        const variantInput = one('.oct-size input:checked');
        const soldOut = variantInput && variantInput.dataset.available === 'false';
        stickyButton.style.whiteSpace = mobile && soldOut ? 'normal' : '';
        stickyButton.textContent = !variantInput ? this.dataset.selectLabel : soldOut ? 'Get email updates' : mobile ? this.dataset.addLabel : `${this.dataset.addLabel} · ${one('[data-sticky-price]').textContent}`;
        this.classList.toggle('has-oct-sticky', visible);
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(updateSticky); };
      const centerCurrent = panel => {
        const current = panel.querySelector('[aria-current="page"]');
        if (current && !panel.hidden) panel.scrollLeft = Math.max(0, current.offsetLeft - panel.offsetLeft - (panel.clientWidth - current.clientWidth) / 2);
      };
      const selectTab = tab => {
        tabs.forEach(button => {
          const active = button === tab;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          panel.hidden = !active;
          if (active) centerCurrent(panel);
        });
        schedule();
      };
      tabs.forEach((tab, index) => {
        on(tab, 'click', () => selectTab(tab));
        on(tab, 'keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          selectTab(tabs[next]);
          tabs[next].focus();
        });
      });
      all('[data-family-panel]').forEach(panel => {
        one(`[data-count="${panel.dataset.familyPanel}"]`).textContent = panel.querySelectorAll('.oct-swatch').length;
        requestAnimationFrame(() => centerCurrent(panel));
      });
      const focusSize = () => {
        one('.oct-sizes').scrollIntoView({ behavior: motion(), block: 'center' });
        (one('.oct-size input:checked') || one('.oct-size input:not(:disabled)'))?.focus({ preventScroll: true });
      };
      const updateVariant = input => {
        one('[data-price]').textContent = input.dataset.price;
        one('[data-sticky-price]').textContent = input.dataset.price;
        const compare = one('[data-compare-price]');
        compare.textContent = input.dataset.comparePrice;
        compare.hidden = !input.dataset.comparePrice;
        const available = input.dataset.available === 'true';
        const pairCard = one('[data-pair]');
        if (pairCard) pairCard.hidden = !available;
        const stock = one('[data-stock]');
        stock.hidden = false;
        stock.textContent = available ? this.dataset.stockLabel : this.dataset.soldLabel;
        stock.dataset.available = String(available);
        add.disabled = false;
        add.hidden = !available;
        one('[data-email-dialog]').hidden = available;
        one('[data-email-size]').textContent = input.dataset.variantTitle;
        add.textContent = available ? `${this.dataset.addLabel} · ${input.dataset.price}` : 'Get email updates';
        one('[data-sticky-add]').disabled = false;
        one('[data-sticky-add]').textContent = available && matchMedia('(max-width: 1023px)').matches ? this.dataset.addLabel : add.textContent;
        one('[data-change-size]').textContent = this.dataset.family === 'sock' ? input.dataset.variantTitle.replace(/^Small.*$/i, 'S').replace(/^Medium.*$/i, 'M') : input.dataset.variantTitle;
        error.hidden = true;
        const url = new URL(location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      };
      sizeInputs.forEach(input => on(input, 'change', () => { this.hasExplicitSizeChoice = true; updateVariant(input); }));
      const selected = one('.oct-size input:checked');
      if (selected) updateVariant(selected);
      const emailDialog = one('[data-email-dialog]');
      const openEmail = () => {
        one('[data-email-size]').textContent = one('.oct-size input:checked')?.dataset.variantTitle || 'This style';
        emailDialog.hidden = false;
        emailDialog.scrollIntoView({ behavior: motion(), block: 'center' });
        emailDialog.querySelector('input[type=email]').focus({ preventScroll: true });
      };

      on(one('[data-email-form]'), 'submit', async event => {
        event.preventDefault();
        const signup = event.currentTarget;
        const button = signup.querySelector('button[type="submit"]');
        if (button.disabled) return;
        const status = one('[data-email-status]');
        button.disabled = true;
        status.textContent = 'Submitting…';
        const input = one('.oct-size input:checked');
        try {
          const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XPAAVF', {
            method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2025-04-15' },
            body: JSON.stringify({ data: { type: 'subscription', attributes: {
              custom_source: 'October PDP sold-out email signup',
              profile: { data: { type: 'profile', attributes: { email: signup.elements.email.value.trim(), properties: {
                'OOS Product': signup.dataset.product, 'OOS Variant ID': input?.value || '', 'OOS Size': input?.dataset.variantTitle || ''
              } } } }
            }, relationships: { list: { data: { type: 'list', id: 'WRPgU3' } } } } })
          });
          if (!response.ok) throw new Error('Please try again in a moment.');
          status.textContent = 'Thanks! Your signup was submitted. If you receive a confirmation email, confirm it to finish joining.';
          signup.reset();
        } catch (failure) { status.textContent = 'We couldn’t submit your signup. Please try again.'; }
        finally { button.disabled = false; }
      });
      const pairChart = one('[data-pair-chart]');
      on(one('[data-pair-chart-open]'), 'click', () => pairChart?.showModal());
      on(one('[data-pair-chart-close]'), 'click', () => pairChart?.close());
      on(pairChart, 'click', event => {
        const bounds = pairChart.getBoundingClientRect();
        if (event.target === pairChart && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) pairChart.close();
      });
      const pairSelect = one('[data-pair-variant]');
      const pairButton = one('[data-pair-add]');
      const pairError = one('[data-pair-error]');
      let pairSizeChosen = false;
      const updatePairPrice = () => {
        const price = pairSelect.selectedOptions[0]?.dataset.price;
        if (price) one('[data-pair-price]').textContent = price;
        pairError.hidden = true;
      };
      const matchPairSize = () => {
        if (!pairSelect || pairSizeChosen) return;
        const size = one('.oct-size input:checked')?.dataset.variantTitle?.trim().toUpperCase();
        const match = [...pairSelect.options].find(option => option.value && !option.disabled && option.dataset.size?.trim().toUpperCase() === size);
        pairSelect.value = match?.value || '';
        updatePairPrice();
      };
      on(pairSelect, 'change', () => {
        pairSizeChosen = true;
        updatePairPrice();
      });
      sizeInputs.forEach(input => on(input, 'change', matchPairSize));
      matchPairSize();
      on(pairButton, 'click', async () => {
        const singlet = one('.oct-size input:checked');
        pairError.hidden = true;
        if (!singlet || singlet.dataset.available !== 'true') {
          pairError.textContent = 'Choose an available size above first.';
          pairError.hidden = false;
          focusSize();
          return;
        }
        if (!pairSelect.value) {
          pairError.textContent = 'Choose a size for the pairing product.';
          pairError.hidden = false;
          pairSelect.focus();
          return;
        }
        if (pairButton.disabled || submitting) return;
        pairButton.disabled = true;
        submitting = true;
        add.disabled = true;
        const stickyAdd = one('[data-sticky-add]');
        stickyAdd.disabled = true;
        pairButton.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(form.action.replace(/\/add(?:\.js)?$/, '/add.js'), {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(singlet.value), quantity: 1 }, { id: Number(pairSelect.value), quantity: 1 }],
              sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
              sections_url: window.location.pathname + window.location.search
            })
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || 'Unable to add the pair. Please check your cart before trying again.');
          document.body.dispatchEvent(new CustomEvent('baseline:cart:afteradditem', {
            bubbles: true, detail: { response: result, sourceId: form.id, originalTarget: pairButton }
          }));
        } catch (failure) {
          pairError.textContent = failure.message || 'Please check your cart before trying again.';
          pairError.hidden = false;
        } finally {
          submitting = false;
          pairButton.disabled = false;
          pairButton.removeAttribute('aria-busy');
          add.disabled = one('.oct-size input:checked')?.dataset.available !== 'true';
          stickyAdd.disabled = add.disabled;
        }
      });
      let submitting = false;
      on(form, 'submit', async event => {
        event.preventDefault();
        if (!one('.oct-size input:checked')) {
          error.textContent = this.dataset.sizeError;
          error.hidden = false;
          focusSize();
          return;
        }
        if (one('.oct-size input:checked')?.dataset.available === 'false') { openEmail(); return; }
        if (submitting) return;
        submitting = true;
        error.hidden = true;
        const stickyAdd = one('[data-sticky-add]');
        add.disabled = true;
        stickyAdd.disabled = true;
        form.setAttribute('aria-busy', 'true');
        try {
          const data = new FormData(form);
          data.set('sections', 'cart-items,cart-footer,cart-item-count,cart-live-region');
          data.set('sections_url', window.location.pathname + window.location.search);
          const response = await fetch(form.action.replace(/\/add(?:\.js)?$/, '/add.js'), {
            method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
          document.body.dispatchEvent(new CustomEvent('baseline:cart:afteradditem', {
            bubbles: true, detail: { response: result, sourceId: form.id, originalTarget: add }
          }));
        } catch (failure) {
          error.textContent = failure.message || 'Unable to add this item. Please try again.';
          error.hidden = false;
        } finally {
          submitting = false;
          form.removeAttribute('aria-busy');
          const unavailable = one('.oct-size input:checked')?.dataset.available !== 'true';
          add.disabled = unavailable;
          stickyAdd.disabled = unavailable;
        }
      });
      on(form, 'invalid', () => {
        error.textContent = this.dataset.sizeError;
        error.hidden = false;
        focusSize();
      }, { capture: true });
      on(add, 'click', event => {
        if (one('.oct-size input:checked')) return;
        event.preventDefault();
        error.textContent = this.dataset.sizeError;
        error.hidden = false;
        focusSize();
      });
      on(one('[data-sticky-add]'), 'click', () => {
        if (!one('.oct-size input:checked')) {
          error.textContent = this.dataset.sizeError;
          error.hidden = false;
          focusSize();
          return;
        }
        form.requestSubmit(add);
      });
      on(one('[data-change-size]'), 'click', focusSize);
      on(one('[data-open-size-chart]'), 'click', () => {
        const activeTab = tabs.find(tab => tab.getAttribute('aria-selected') === 'true');
        const activePanel = activeTab && document.getElementById(activeTab.getAttribute('aria-controls'));
        const chartFamily = activePanel?.dataset.familyPanel || this.dataset.family;
        const pictures = all('[data-chart-family]');
        const selectedChart = pictures.find(picture => picture.dataset.chartFamily === chartFamily);
        pictures.forEach(picture => { picture.hidden = picture !== (selectedChart || pictures[0]); });
        chart.showModal();
      });
      on(one('[data-close-dialog]'), 'click', () => chart.close());
      on(chart, 'click', event => { if (event.target === chart && (event.clientX < chart.getBoundingClientRect().left || event.clientX > chart.getBoundingClientRect().right || event.clientY < chart.getBoundingClientRect().top || event.clientY > chart.getBoundingClientRect().bottom)) chart.close(); });
      const galleryVideos = all('.oct-gallery video');
      const galleryVideoState = new Map(galleryVideos.map(video => [video, { visible: false, userPaused: false, pendingPauses: 0, autoplayBlocked: false, fallback: video.parentElement.querySelector('[data-gallery-video-play]') }]));
      const updateGalleryVideoControls = video => {
        const state = galleryVideoState.get(video);
        video.setAttribute('aria-label', video.dataset[video.paused ? 'playLabel' : 'pauseLabel']);
        if (state.fallback) state.fallback.hidden = !video.paused || !state.visible || document.hidden || state.userPaused || video.ended || (!state.autoplayBlocked && !matchMedia('(prefers-reduced-motion: reduce)').matches);
      };
      const pauseGalleryVideo = video => {
        if (video.paused) return;
        galleryVideoState.get(video).pendingPauses += 1;
        video.pause();
      };
      const playGalleryVideo = video => {
        const state = galleryVideoState.get(video);
        state.userPaused = false;
        video.muted = true;
        video.playsInline = true;
        video.play().catch(error => {
          if (error.name !== 'AbortError') state.autoplayBlocked = true;
          updateGalleryVideoControls(video);
        });
      };
      const syncGalleryVideos = () => galleryVideoState.forEach((state, video) => {
        if (!state.visible || document.hidden) pauseGalleryVideo(video);
        else if (!state.userPaused && !state.autoplayBlocked && !video.ended && video.paused && !matchMedia('(prefers-reduced-motion: reduce)').matches) playGalleryVideo(video);
        updateGalleryVideoControls(video);
      });
      galleryVideos.forEach(video => {
        const toggleVideo = () => {
          if (video.paused) playGalleryVideo(video);
          else {
            galleryVideoState.get(video).userPaused = true;
            pauseGalleryVideo(video);
          }
          updateGalleryVideoControls(video);
        };
        on(video, 'click', toggleVideo);
        on(video, 'keydown', event => {
          if (![' ', 'Enter'].includes(event.key)) return;
          event.preventDefault();
          if (!event.repeat) toggleVideo();
        });
        on(galleryVideoState.get(video).fallback, 'click', () => {
          video.focus({ preventScroll: true });
          playGalleryVideo(video);
        });
        on(video, 'pause', () => {
          const state = galleryVideoState.get(video);
          if (state.pendingPauses) state.pendingPauses -= 1;
          else if (!video.ended) state.userPaused = true;
          updateGalleryVideoControls(video);
        });
        on(video, 'play', () => {
          const state = galleryVideoState.get(video);
          if (!video.paused) {
            state.userPaused = false;
            state.autoplayBlocked = false;
          }
          if (!state.visible || document.hidden) pauseGalleryVideo(video);
          updateGalleryVideoControls(video);
        });
        on(video, 'ended', () => updateGalleryVideoControls(video));
      });
      this.galleryVideoObserver = new IntersectionObserver(entries => {
        entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
          galleryVideoState.get(target).visible = isIntersecting && intersectionRatio >= 0.6;
        });
        syncGalleryVideos();
      }, { threshold: [0, 0.6] });
      galleryVideos.forEach(video => this.galleryVideoObserver.observe(video));
      on(document, 'visibilitychange', syncGalleryVideos);
      this.pauseGalleryVideos = () => galleryVideos.forEach(pauseGalleryVideo);
      const photoCount = one('[data-gallery-count]');
      on(gallery, 'scroll', () => { if (photoCount) photoCount.textContent = `${Math.round(gallery.scrollLeft / gallery.clientWidth) + 1} / ${gallery.children.length}`; }, { passive: true });
      on(one('[data-next-photo]'), 'click', () => gallery.scrollTo({ left: ((Math.round(gallery.scrollLeft / gallery.clientWidth) + 1) % gallery.children.length) * gallery.clientWidth, behavior: motion() }));
      all('.oct-assurances a').forEach(link => on(link, 'click', () => { const details = document.getElementById(link.hash.slice(1)); if (details) details.open = true; }));
      const reviewPanel = one('[data-reviews]');
      const reviewBadge = one('.oct-review-badge');
      const widget = one('#judgeme_product_reviews');
      const summary = document.createElement('div');
      summary.className = 'oct-review-summary';
      reviewPanel.querySelector('summary').textContent = 'Reviews';
      reviewPanel.querySelector('summary').after(summary);
      reviewPanel.classList.add('oct-reviews-expanded');
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'oct-rating-badge';
      const stars = document.createElement('span');
      stars.className = 'oct-rating-stars'; stars.setAttribute('aria-hidden','true');
      stars.textContent = '★★★★★';
      const ratingLabel = document.createElement('span');
      button.append(stars,ratingLabel);
      reviewBadge.replaceChildren(button);
      let reviewScopeKey = '';
      let sharedSingletReviews = false;
      const updateReviews = () => {
        const source = widget.querySelector('.jdgm-rev-widg');
        const productAverage = Number(source?.dataset.averageRating);
        const productCount = Number(source?.dataset.numberOfReviews);
        const average = productAverage;
        const count = productCount;
        const scopeKey = `${average}:${count}`;
        if (reviewScopeKey !== scopeKey) {
          reviewScopeKey = scopeKey;
          sharedSingletReviews = false;
        }
        const isSinglet = this.dataset.family === 'singlet' || this.dataset.family === 'crop';
        const reviews = Array.from(source?.querySelectorAll('.jdgm-rev[data-product-url]') || []);
        const hasOtherProduct = reviews.some(review => review.dataset.productUrl && review.dataset.productUrl !== this.dataset.productUrl);
        const onlySinglets = reviews.length > 0 && reviews.every(review => /singlet/i.test(review.dataset.productTitle || ''));
        if (!isSinglet || (reviews.length > 0 && !onlySinglets)) sharedSingletReviews = false;
        else if (hasOtherProduct && onlySinglets) sharedSingletReviews = true;
        const scopeLabel = sharedSingletReviews ? this.dataset.singletRatingLabel : this.dataset.productRatingLabel;
        const countLabel = sharedSingletReviews ? this.dataset.singletReviewsLabel : this.dataset.productReviewsLabel;
        const visible = Number.isInteger(count) && count > 0 && Number.isFinite(average) && average >= 1 && average <= 5;
        const productVisible = Number.isInteger(productCount) && productCount > (['cap', 'tight'].includes(this.dataset.family) ? 0 : 10) && Number.isFinite(productAverage) && productAverage >= 1 && productAverage <= 5;
        reviewBadge.hidden = !visible;
        reviewPanel.hidden = !visible && !productVisible;
        summary.hidden = !visible;
        widget.hidden = !productVisible;
        const ratingKey = `${average}:${count}:${sharedSingletReviews}`;
        if (summary.dataset.rating === ratingKey) return;
        summary.dataset.rating = ratingKey;
        if (visible) {
          stars.style.setProperty('--rating-fill', `${average / 5 * 100}%`);
          ratingLabel.textContent = `${average.toFixed(1)}/5`;
          button.setAttribute('aria-label', `${scopeLabel}: ${average.toFixed(1)}/5`);
          const score = document.createElement('strong'); score.textContent = `${average.toFixed(1)}/5`;
          const total = document.createElement('span'); total.textContent = countLabel.replace('[count]', String(count));
          summary.replaceChildren(score,stars.cloneNode(true),total);
        }
      };
      this.reviewObserver = new MutationObserver(updateReviews);
      this.reviewObserver.observe(widget,{childList:true,subtree:true,attributes:true,attributeFilter:['data-average-rating','data-number-of-reviews']});
      updateReviews();
      on(button,'click',event => {
        event.preventDefault(); event.stopImmediatePropagation();
        reviewPanel.open = true;
        requestAnimationFrame(() => reviewPanel.scrollIntoView({behavior:motion(),block:'start'}));
      },{capture:true});
      on(window, 'scroll', schedule, { passive: true });
      on(window, 'resize', schedule);
      const scheduleMobile = () => { if (matchMedia('(max-width: 1023px)').matches) schedule(); };
      on(window.visualViewport, 'resize', scheduleMobile);
      on(document, 'focusin', scheduleMobile);
      on(document, 'focusout', scheduleMobile);
      this.resizeObserver = new ResizeObserver(() => { buy.style.setProperty('--oct-panel-height', `${buy.offsetHeight}px`); schedule(); });
      this.resizeObserver.observe(buy);
      const videos = all('.oct-ugc-video');
      this.videoObserver = new IntersectionObserver(entries => entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting && !document.hidden && !matchMedia('(prefers-reduced-motion: reduce)').matches) target.play().catch(() => {});
        else target.pause();
      }), { threshold: 0.25 });
      videos.forEach(video => this.videoObserver.observe(video));
      on(document, 'visibilitychange', () => { if (document.hidden) videos.forEach(video => video.pause()); });
      all('.oct-community-carousel').forEach(carousel => on(carousel, 'keydown', event => {
        if (!['ArrowRight', 'ArrowLeft'].includes(event.key)) return;
        event.preventDefault();
        carousel.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * carousel.clientWidth * 0.7, behavior: motion() });
      }));
      updateSticky();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.videoObserver?.disconnect();
      this.galleryVideoObserver?.disconnect();
      this.pauseGalleryVideos?.();
      this.reviewObserver?.disconnect();
      this.ready = false;
    }
  });
}

